import {GeneralEntity} from '../generalEntity';

export class UserRightGroupUi extends GeneralEntity {
  groupId: number;
  groupName: string;
  userRightName: string;
  userRightId: number;
  userRightTarget: string;
  frontWrite: boolean;
  frontRead: boolean;
  backWrite: boolean;
  backRead: boolean;

  isFrontWriteChanged: boolean;
  isFrontReadChanged: boolean;
  isBackWriteChanged: boolean;
  isBackReadChanged: boolean;
  isChanged: boolean;

  get isAllSelected(): boolean {
    return this.frontWrite && this.frontRead && this.backWrite && this.backRead;
  }

  set isAllSelected(val: boolean) {
    this.frontWrite = val;
    this.frontRead = val;
    this.backWrite = val;
    this.backRead = val;
    this.isFrontReadChanged = true;
    this.isFrontWriteChanged = true;
    this.isBackWriteChanged = true;
    this.isBackReadChanged = true;
    this.isChanged = true;
  }

  get isAllBackSelected(): boolean {
    return this.backRead && this.backWrite;
  }

  set isAllBackSelected(val: boolean) {
    this.backRead = val;
    this.backWrite = val;
    this.isBackWriteChanged = true;
    this.isBackReadChanged = true;
    this.isChanged = true;
  }

  get isAllFrontSelected(): boolean {
    return this.frontRead && this.frontWrite;
  }

  set isAllFrontSelected(val: boolean) {
    this.frontRead = val;
    this.frontWrite = val;
    this.isFrontWriteChanged = true;
    this.isFrontReadChanged = true;
    this.isChanged = true;
  }

  public backWriteChanged(): void {
    this.isBackWriteChanged = true;
    this.isChanged = true;
  }

  public backReadChanged(): void {
    this.isBackReadChanged = true;
    this.isChanged = true;
  }

  public frontWriteChanged(): void {
    this.isFrontWriteChanged = true;
    this.isChanged = true;
  }

  public frontReadChanged(): void {
    this.isFrontReadChanged = true;
    this.isChanged = true;
  }

}
